import React from 'react'

export default function Footer(props) {
    return (
        <footer className="covid-footer text-center bg-primary py-3">
            <p className="mb-0 text-white">COVID-19 GLOBAL @Made by Son 2021</p>
        </footer>
    )
}
